// src/services/reviewService.js
import { catalogApi, authSecureApi } from '../utils/apiConfig';

export const reviewService = {
  getSummary: async (outletVariantId) => {
    try {
      const response = await catalogApi.get(`/api/v1/reviews/${outletVariantId}/summary`, {
        params: { status: true }
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching reviews summary:", error);
      throw error;
    }
  },

  addReview: async (reviewData, files) => {
    try {
      const formData = new FormData();
      // Wrapping object as Blob with application/json type is standard for Spring Boot Multipart
      formData.append('review', new Blob([JSON.stringify(reviewData)], { type: 'application/json' }));
      
      if (files && files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          formData.append('files', files[i]);
        }
      }

      const response = await authSecureApi.post('/api/v1/reviews/add', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      console.error("Error adding review:", error);
      throw error;
    }
  },

  editReview: async (reviewId, reviewData, files) => {
    try {
      const formData = new FormData();
      formData.append('review', new Blob([JSON.stringify(reviewData)], { type: 'application/json' }));
      
      if (files && files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          formData.append('files', files[i]);
        }
      }

      const response = await authSecureApi.put(`/api/v1/reviews/edit/${reviewId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      console.error("Error editing review:", error);
      throw error;
    }
  },

  // NEW: Delete review API
  deleteReview: async (reviewId) => {
    try {
      // Status false indicates deletion
      const response = await authSecureApi.put(`/api/v1/reviews/${reviewId}/status?status=false`);
      return response.data;
    } catch (error) {
      console.error("Error deleting review:", error);
      throw error;
    }
  }
};